import { render, staticRenderFns } from "./PaginationSection.vue?vue&type=template&id=0bc50b6d&scoped=true"
import script from "./PaginationSection.vue?vue&type=script&lang=js"
export * from "./PaginationSection.vue?vue&type=script&lang=js"
import style0 from "./PaginationSection.vue?vue&type=style&index=0&id=0bc50b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc50b6d",
  null
  
)

export default component.exports